import { render, staticRenderFns } from "./SignupsByType.vue?vue&type=template&id=5206c85f&scoped=true"
import script from "./SignupsByType.vue?vue&type=script&lang=js"
export * from "./SignupsByType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5206c85f",
  null
  
)

export default component.exports